export class AzureEntraIdRestoreConsent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "AzureEntraIdRestoreConsentKindEnum",
            "format": ""
        },
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "permission",
            "baseName": "permission",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalId",
            "baseName": "principalId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureEntraIdRestoreConsent.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureEntraIdRestoreConsentKindEnum;
(function (AzureEntraIdRestoreConsentKindEnum) {
    AzureEntraIdRestoreConsentKindEnum["Application"] = "application";
    AzureEntraIdRestoreConsentKindEnum["Delegated"] = "delegated";
    AzureEntraIdRestoreConsentKindEnum["User"] = "user";
})(AzureEntraIdRestoreConsentKindEnum || (AzureEntraIdRestoreConsentKindEnum = {}));
